import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";

const pendo = {
    initialize: (id) => {
        apiGet(apiUrls.getUserInfo(id)).then((response) => {
            var account = null;
            if (response.data.companyId) {
                account = {
                    id: `${response.data.companyId}`,
                    company_code: response.data.companyCode,
                    environment: response.data.environment,
                    user_role: response.data.roles,
                };

                if (response.data.insuredId) {
                    account.id = response.data.insuredId;
                    account.company_id = response.data.companyId;
                }
            }

            window.pendo.initialize({
                visitor: {
                    id: `${response.data.loginId}`,
                    environment: response.data.environment,
                },

                account
            });
        });

        window.pendo.skipStepNoElement = (guide, step) => {
            if (guide && guide.steps) {
                var nextStep = guide.steps[guide.getPositionOfStep(step)];

                var results = window.pendo.Sizzle(nextStep.elementPathRule);
                var isVisible = window.pendo._.some(results, pendo.isElementVisible);

                if (results.length === 0 || !isVisible) {
                    window.pendo.log(guide.id + ':advance 2 steps');
                    window.pendo.onGuideAdvanced({steps: 2});
                } else {
                    window.pendo.log(guide.id + ':advance 1 step');
                    window.pendo.onGuideAdvanced();
                }
            }
        }
    }
}
export default pendo;